module.exports = __webpack_public_path__ + "media/images/icons/next_green-79f8205ff7d5d1d5d7e7fd10d118ba95.svg";